import React, { useState } from "react";
import styles from "./Offers.module.css"

import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { Col, Row } from "react-bootstrap";
import { Carousel } from 'react-responsive-carousel';
import { productListingType } from "../../utilities/settings";

interface IOffer {
    promotionHeaderId: number,
    promoName: string,
    promoDescription: string,
    imageURL: string,
    createdOn: string,
    onClickActionType: number,
    promotionDetails: any,
    promotionCode: string
}

export interface IOffers {
    offers: IOffer[]
}

export default function Offers(props: IOffers) {
    const dispatch = useDispatch();
    const responsive = useSelector((state: RootState) => state.responsive);

    // carousel slide states
    const [slide1, setSlide1] = useState(0);
    const [slide2, setSlide2] = useState(1);
    const [slide3, setSlide3] = useState(2);

    function onRightArrowClick() {
        setSlide1(props.offers[slide1 + 1] ? slide1 + 1 : 0);
        setSlide2(props.offers[slide2 + 1] ? slide2 + 1 : 0);
        setSlide3(props.offers[slide3 + 1] ? slide3 + 1 : 0);
    }

    function onLeftArrowClick() {
        let firstSlide = props.offers[slide1 - 1] ? slide1 - 1 : props.offers.length - 1;
        let secondSlide = props.offers[slide2 - 1] ? slide2 - 1 : props.offers.length - 1;
        let thirdSlide = props.offers[slide3 - 1] ? slide3 - 1 : props.offers.length - 1;
        setSlide1(props.offers[firstSlide] ? firstSlide : 0);
        setSlide2(props.offers[secondSlide] ? secondSlide : 0);
        setSlide3(props.offers[thirdSlide] ? thirdSlide : 0);
    }

    function onClickImg(slide: IOffer) {
        if (slide.onClickActionType == 1) {
            window.location.href = (`/offers/${slide.promotionCode.replace(/[/ ]/g, "_").toLowerCase()}`)
        }
        else if (slide.onClickActionType == 2) {
            if (slide.promotionDetails.length > 0) {
                window.location.href = `/products/${productListingType.offer.toLowerCase()}/${slide.promotionCode.replace(/[/ ]/g, "_").toLowerCase()}`;
            }
            else {
                window.location.href = (`/offers/${slide.promotionCode.replace(/[/ ]/g, "_").toLowerCase()}`)
            }
        }
        else if (slide.onClickActionType == 3) {
            if (slide.promotionDetails.length > 0) {
                window.location.href = ("/productDetails?ic=" + slide.promotionDetails[0].itemCode + "&" + slide.promotionDetails[0].itemName.replace(/ /g, "_").toUpperCase())
            }
            else {
                window.location.href = (`/offers/${slide.promotionCode.replace(/[/ ]/g, "_").toLowerCase()}`)
            }
        }
    }

    return (<React.Fragment>
        {responsive.isMobileSmallScreen || responsive.isMobileLargeScreen || responsive.isTabScreen ?
            <Row className="home-section-container" style={{ paddingBottom: "2rem" }}>
                <Col md="12" className="home-section-main-heading">Special Offers</Col>
                <Col md="12">
                    Deals that you cannot miss all throughout the year! Discounts, Surprises and Free gifts for your purchases. Shop with us and enjoy special deals and great savings.
                </Col>
                <Col md="12">
                    <Carousel
                        autoPlay={true}
                        showArrows={false}
                        swipeable={true}
                        showStatus={false}
                        infiniteLoop={true}
                        showIndicators={true}
                        showThumbs={false}
                    >
                        {props.offers.map((item, index) => {
                            return (
                                <div key={index} className="d-flex justify-content-center">
                                    <div onClick={() => onClickImg(item)}>
                                        <img src={item.imageURL} alt={item.promoName + `-img`} className="img-fluid" />
                                    </div>
                                </div>
                            );
                        })}
                    </Carousel>
                </Col>
            </Row>
            :
            <Row className={` ${styles.offersContainer} home-section-container`} >
                <Col md="6">
                    <img src={props.offers[slide1].imageURL} onClick={() => onClickImg(props.offers[slide1])} alt={`firstOffer-img`} className={`${styles.mainImage} img-fluid`} style={{ cursor: "pointer" }}></img>
                </Col>
                <Col md="6">
                    <Col md="12" className="home-section-small-heading" hidden>Lorem ipsum dior</Col>
                    <Col md="12" className="home-section-main-heading">Special Offers</Col>
                    <Col md="12" style={{ paddingBottom: "18px" }}>
                        Deals that you cannot miss all throughout the year! Discounts, Surprises and Free gifts for your purchases. Shop with us and enjoy special deals and great savings.
                    </Col>

                    <Col md="12" className={`${styles.controlsContainer}`} >
                        <i style={{ marginRight: "1rem", cursor: "pointer" }} className="fas fa-long-arrow-alt-left" onClick={() => onLeftArrowClick()}></i>
                        <i style={{ cursor: "pointer" }} className="fas fa-long-arrow-alt-right" onClick={() => onRightArrowClick()}></i></Col>
                    <Col md="12">
                        <div className="d-flex overflow-hidden">
                            <img src={props.offers[slide2].imageURL} alt={`secondOffer-img`} onClick={() => onClickImg(props.offers[slide2])} style={{ marginRight: "2rem", minWidth: "70%", height: "70%", cursor: "pointer" }} className={`${styles.subImage} img-fluid`}></img>
                            <img src={props.offers[slide3].imageURL} alt={`thirdOffer-img`} onClick={() => onClickImg(props.offers[slide3])} style={{ minWidth: "70%", height: "70%", cursor: "pointer" }} className={`${styles.subImage} img-fluid`}></img>
                        </div>
                    </Col>
                </Col>
            </Row>
        }

    </React.Fragment>)
}